<template>
    <div class="card product-gallery">
        <div class="card-header">
            <h3>
                {{ lang.bspu_gallery }}
                <span v-if="productItem">{{ productItem.product_name }}</span>
            </h3>
        </div>
        <div class="card-body">
            <article class="gallery-list" style="margin-top: 0px;">
                <input type="file" ref="imageCover" accept="image/jpeg,image/jpg,image/png," style="display:none;" @change="uploadFile($event, 'cover')">
                <input type="file" ref="image" accept="image/jpeg,image/jpg,image/png," style="display:none;" @change="uploadFile($event, 'img')">
                <input type="file" ref="video" accept="video/mp4" style="display:none" @change="uploadFile($event, 'video')">
                <ul>
                    <li class="gallery_item cover_img" @click.prevent="$refs.imageCover.click()">
                        <button class="btn btn-primary" >{{ lang.bspu_cover_image }}</button>
                        <div class="gallery_media" style="cursor: pointer;">
                            <img v-if="itemCover" class="item_media" :src="urlMedia+'/'+itemCover.type_file+'/'+itemCover.name_file" :alt="itemCover.name_file" />
                            <img v-else class="item_media" src="@/core/assets/img/add-img-icon.png" :alt="lang.bspu_add_image" >
                        </div>
                    </li>
                    <li :class="['gallery_item video']" >
                        <div v-if="itemVideo" class="gallery_media" style="cursor: pointer;" @click.prevent="!coverAsigned ? null : $refs.video.click()">
                            <img class="item_media" :src="urlMedia+'/video/'+itemVideo.name_file+'.jpg'" :alt="itemVideo.name_file"/>
                            <i class="fas fa-play-circle" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: #fff; font-size: 2rem;"></i>
                        </div>
                        <div :class="['gallery_media', !coverAsigned ? 'disabled' : '']" style="cursor: pointer;" v-else @click.prevent="!coverAsigned ? null : $refs.video.click()">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M128 128C92.7 128 64 156.7 64 192L64 448C64 483.3 92.7 512 128 512L384 512C419.3 512 448 483.3 448 448L448 192C448 156.7 419.3 128 384 128L128 128zM496 400L569.5 458.8C573.7 462.2 578.9 464 584.3 464C597.4 464 608 453.4 608 440.3L608 199.7C608 186.6 597.4 176 584.3 176C578.9 176 573.7 177.8 569.5 181.2L496 240L496 400z"/></svg>
                        </div>
                    </li>
                </ul>
            </article>
            <article class="gallery-list" v-if="productItem.gallery && productItem.gallery.length>0">
                <draggable v-model="productItem.gallery" tag="ul" v-bind="dragOptions" @change="checkMove" @start="isDragging = true" @end="isDragging = false" handle=".handle">
                    <li class="gallery_item" v-for="(g, gIdx) in productItem.gallery" :key="gIdx" v-if="g.cover==0 && g.type_file=='img'">
                        <button class="btn-move handle"><i class="fas fa-arrows-alt"></i></button>
                        <div class="gallery_media">
                            <img v-if="g.type_file=='img'" class="item_media" :src="urlMedia+'/'+g.type_file+'/'+g.name_file" :alt="g.name_file" >
                            <video v-else :src="urlMedia+'/'+g.type_file+'/'+g.name_file" muted loop preload="auto" :poster="urlMedia+'/video/'+g.name_file+'.jpg'" class="item_media"></video>
                            <div class="gallery_media_icon">
                                <i class="fas fa-image" v-if="g.type_file=='img'"></i>
                                <i class="fas fa-video" v-else></i>
                            </div>
                        </div>
                        <button class="btn-del" @click.prevent="deleteConfirm(g, gIdx)"><i class="fas fa-trash-alt"></i></button>
                    </li>
                    <li class="gallery_item" v-if="coverAsigned">
                        <div class="gallery_media" @click.prevent="$refs.image.click()" style="cursor: pointer;">
                            <img class="item_media" src="@/core/assets/img/add-img-icon.png" :alt="lang.bspu_add_image" >
                        </div>
                    </li>
                </draggable>
            </article>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
export default {
    components: {
        draggable,
    },
    data() {
        return {
            lang: {
                bspu_gallery: '',
                bspu_cover_image: '',
                bspu_add_image: '',
                bspu_upload_error: '',
                bspu_to_remove_items: '',
                bs_swal_delete_title: '',
                bs_swal_text: '',
                bs_swal_confirm: '',
                bspu_could_not_delete: '',
                bs_error: '',
                bs_could_not_save: '',
            },
            isLoading: false,
            productItem: null,
            apis: null,
            urlMedia: null,
            apiProgess: 0,
            isDragging: false,
            coverAsigned: false,
            onlyVideo: false,
            itemCover: null,
            itemVideo: null,
        }
    },
    computed: {
        ...mapGetters("ModApps/Marketea/", {
            langGetter: "lang",
        }),
        dragOptions() {
            return {
                animation: 200,
                group: "gallery",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    },
    created(){
        let t = this;
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.bStore;
        t.productItem = t.$store.getters['core/getOpenModal'].data.productItem;
        t.urlMedia = t.$store.getters['core/getOpenModal'].data.urlMedia;
        t.$store.commit("core/setLoadingModal", false);
        t.getCoverVideo();
    },
    watch: {
        langGetter() { this.lang = this.$store.getters['ModApps/Marketea/lang']; },
    },
    methods: {
        getCoverVideo(){
            let t = this;
            t.coverAsigned = false;
            t.onlyVideo = false;
            t.itemCover = null;
            t.itemVideo = null;
            if(t.productItem.gallery && t.productItem.gallery.length>0){
                t.productItem.gallery.map((item) => {
                    console.log('item', item.type_file, item.cover);
                    if(item.type_file=='img' && item.cover==1){
                        t.coverAsigned = true;
                        t.itemCover = item;
                    }
                    if(item.type_file=='video'){
                        t.onlyVideo = true;
                        t.itemVideo = item;
                    }
                });
            }
        },
        uploadFile(e, type){
            let t = this;
            if (e.target.files && e.target.files.length==1) {
                let file = e.target.files[0];
                t.isLoading = true;
                let urlService = t.apis.set(5);//setProductGalleries
                var f = new FormData();
                // @ts-ignore
                f.append("user_id", window.master_client);
                // @ts-ignore
                f.append("org_id", window.localuserdata);
                f.append("pusher_id", pusher.connection.socket_id);
                f.append("type_file", type);
                f.append('file', file, file.name);
                f.append('group_id', t.productItem.group_id);
                f.append('cat_id', t.productItem.cat_id);
                f.append('product_id', t.productItem.id);
                t.$store.commit("core/setLoadingModal", true);
                // @ts-ignore
                window.master.post(urlService, f, {
                    headers: {
                        common: {
                        // @ts-ignore
                        Authorization: 'Bearer ' + window.localtoken_M
                        },
                        post: { 'Content-Type': 'multipart/form-data' }
                    },
                    onUploadProgress: (progressEvent) => {
                        // console.log('onUploadProgress', progressEvent)
                        let scanPer = Math.floor(
                            (progressEvent.loaded*100 / progressEvent.total)
                        );
                        // console.log('scanPer', scanPer);
                        if(scanPer < 99){
                            t.apiProgess = scanPer;
                        }
                    }
                })
                .then((response) => {
                    t.apiProgess =100;
                    t.$store.commit("core/setLoadingModal", false);
                    console.log(urlService, response.data);
                    t.isLoading = false;
                    t.$refs.image.value=null;
                    t.$refs.video.value=null;
                    if(!response.data.status){
                        t.$notify({
                            group: "noti",
                            type: "error",
                            title: t.lang.bs_error,
                            text: t.lang.bspu_upload_error,
                        });
                    }else{
                        // exito, agregar nuevo item,
                        t.$store.commit('ModApps/Marketea/set_bStoreAddGalleryItem', response.data.result);
                        setTimeout(() => {
                            t.getCoverVideo();
                        }, 500);
                    }
                }).catch((error) => {
                    console.log(error);
                    t.apiProgess =0;
                    t.$store.commit("core/setLoadingModal", false);
                    t.isLoading = false;
                    t.$refs.image.value=null;
                    t.$refs.video.value=null;
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: t.lang.bs_error,
                        text: t.lang.bs_could_not_save,
                    });
                });
            }
        },
        checkMove() {
            let t = this;
            let d = t.$store.getters['core/getOpenModal'].data;
            t.productItem.gallery.map((item, index) => {
                item.orden = index;
            });
            let urlService = t.apis.set(6)// setGalleryOrden
            // @ts-ignore
            window.master.post(urlService, {
                ordenGalleries: t.productItem.gallery,
            })
            .then((response) => {
                console.log(urlService, response.data);
            })
            .catch((error) => {
                console.log(error);
                t.$notify({
                    group: "noti",
                    type: "error",
                    title: t.lang.bs_error,
                    text: t.lang.bs_could_not_save,
                });
            });
        },
        deleteConfirm(i, indexVal) {
            let t = this;
            if(!i.name_file || i.name_file.length==0){
                t.$notify({
                    group: "noti",
                    type: "error",
                    title: t.lang.bs_error,
                    text: t.lang.bspu_to_remove_items,
                });
            }else{
                t.$swal({
                    title: t.lang.bs_swal_delete_title,
                    text: t.lang.bs_swal_text,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: t.lang.bs_swal_confirm,
                }).then((result) => {
                    if (result.value) {
                        console.log('delete item', i.name_file)
                        t.$store.commit('ModApps/Marketea/set_bStoreDelGalleryItem', i);
                        t.deleteItem(i, indexVal);
                    }
                });
            }
        },
        deleteItem(i, indexVal) {
            let t = this;
            if (i.id > 0) {
                let urlService = t.apis.set(7)// deleteGallery
                // @ts-ignore
                window.master.post(urlService, i)
                .then((response) => {
                    console.log(urlService, i, response.data);
                })
                .catch((error) => {
                    console.log(error);
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: t.lang.bs_error,
                        text: t.lang.bspu_could_not_delete,
                    });
                });
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .card.product-gallery{
        .card-header{
            padding: 10px 15px;
            h3{margin: 0px;}
        }
    }
    .btn-upload{
        display: flex;
        ul{
            list-style: none;
            margin: 0px;
            padding: 0px;
            display: flex;
            li{
                margin-right: 10px;
            }
        }
    }
    .gallery-list{
        margin-top:20px;
        display: flex;
    }
    ul{
        list-style: none;
        margin: 0px;
        padding: 0px;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        li{
            position: relative;
            margin-right: 10px;
            margin-bottom: 20px;
            flex: none;
            button{
                position: absolute;
                z-index: 1;
                border:0px;
                box-shadow: none;
                background: #fff;
                color:#000;
                border-radius: 4px;
                cursor: pointer;
                &.btn-move{
                    top: 0px;
                    left: 0px;
                    z-index: 2;
                    background-color: rgb(145 193 239 / 75%);
                    color: #113cfc;
                    cursor: move;
                }
                &:disabled{
                    cursor: not-allowed;
                    opacity: 0.5;
                    background: transparent!important;
                }
                &.btn-cover{
                    right: 0;
                    top: -10px;
                    border: 1px solid #eee;
                    display: flex;
                    align-items: center;
                    i{
                        font-size: 1.2rem;
                        margin-left: 5px;
                    }
                }
                &.btn-del{
                    right: 0;
                    bottom: 0;
                    color: #f5f1f1;
                    background-color: #fa5838;
                    border-color: #fa5838;
                }
            }
            &.gallery_item {
                width:100%;
                max-height: 200px;
                min-height: 200px;
                max-width: 250px;
                justify-content: center;
                display: flex;
                transition: .3s ease-out all;
                border-radius: 4px;
                border:1px solid #eee;
                overflow: hidden;
                .gallery_media{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    &.disabled{
                        pointer-events: none;
                        opacity: 0.5;
                    }
                    .item_media{
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        object-position: center;
                    }
                    .gallery_media_icon{
                        position: absolute;
                        height: 50px;
                        width: 50px;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        z-index: 1;
                        margin: auto;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #fff;
                        text-shadow: 0 0 10px rgba(0, 0, 0, 0.30);
                        background-color: rgba(0, 0, 0, 0.30);
                        font-size: 1.5rem;
                        border-radius: 20px;
                    }
                }
            }
        }
    }
</style>
